export enum AnalyticsActionTypeName {
    CONFIRM = 'Confirm',

    PERSONALIZATION = 'Personalization',
}
